<div class="flex-vertical gap-16 width-100pc">
  <div class="body-2">
    {{ totalCount }} <span *ngIf="totalCount > 1">fiches conseil</span><span *ngIf="totalCount < 2">fiche conseil</span>
  </div>
  <div class="width-100pc">
    <oui-table *ngIf="!isLoading && dataSource.filteredData.length > 0">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef>Libellé</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-long">{{ element.label }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="natureOperation">
          <th mat-header-cell *matHeaderCellDef>Nature d'opération</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-long" [innerText]="element.natureOperationLabel"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="investisseurName">
          <th mat-header-cell *matHeaderCellDef>Investisseur</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-long" [innerText]="element.investisseurName"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="enveloppeName">
          <th mat-header-cell *matHeaderCellDef>Enveloppe</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-short">{{ element.enveloppeName }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="montant">
          <th mat-header-cell *matHeaderCellDef class="header-right">Montant</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-right nowrap">{{ element.montant | montant : '€' }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="dateModification">
          <th mat-header-cell *matHeaderCellDef class="header-right">Mise à jour</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-right">{{ element.dateModification | date : 'dd/MM/yyyy' }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="statut">
          <th mat-header-cell *matHeaderCellDef>Statut</th>
          <td mat-cell *matCellDef="let element">
            <div class="content-fixed">
              <div class="flex-horizontal flex-center justify-space-between">
                <lib-fiche-conseil-statut-tag [statut]="element.statut"></lib-fiche-conseil-statut-tag>
                <app-fiche-conseil-table-more-action
                  [row]="element"
                  class="content-fixed"
                  (onReloadRequired)="reloadFiches()"></app-fiche-conseil-table-more-action>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <ng-container *ngIf="!isLoading">
          <tr
            mat-row
            [class.interactive]="true"
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick(row)"></tr>
        </ng-container>
      </table>

      <oui-paginator
        *ngIf="totalCount > 20"
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize">
      </oui-paginator>
    </oui-table>
    <div class="etat-vide-container" *ngIf="isLoading || dataSource.filteredData.length === 0">
      <oui-etat-vide *ngIf="!isLoading" title="Aucun résultat" icon="live_help"></oui-etat-vide>
      <oui-loading *ngIf="isLoading"></oui-loading>
    </div>
  </div>
</div>
